module.exports = __webpack_public_path__ + "static/img/icon0.fdd07fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon0.png
// module id = SMDe
// module chunks = 1